import React from 'react'
import * as Accordion from '@radix-ui/react-accordion'
import classNames from 'classnames'
import getBottomInfo from './helpers/getBottomInfo'
import locales from './helpers/locales'

import * as styles from './Footer.css'
import * as desktopStyles from './components/DesktopFooterWrapper/DesktopFooterWrapper.css'

import varReplace from '../../utils/varReplace'
import getSocials from './helpers/getSocials'
import {
  AccordionContent,
  AccordionTriggerGuidelines,
} from './components/Accordions/Accordions'
import DesktopFooterWrapper from './components/DesktopFooterWrapper/DesktopFooterWrapper'
import MobileFooterWrapper from './components/MobileFooterWrapper/MobileFooterWrapper'
import { FooterProps } from './components/footerWrapper'

const Footer: React.FC<FooterProps> = ({
  lang = 'pt',
  isCollapsible = false,
}) => (
  <footer className={styles.FooterContainer}>
    <div className={styles.ContentWrapper}>
      <div className={styles.FooterWrapper}>
        <DesktopFooterWrapper lang={lang} isCollapsible={isCollapsible} />
        <MobileFooterWrapper lang={lang} />
      </div>
      <section className={styles.BottomContent}>
        <div className={styles.SymplaInfoBoxContainer.Mobile}>
          <Accordion.Root
            className="AccordionRoot"
            collapsible
            type="single"
            id="component-footer-guidelines"
          >
            <Accordion.Item value="guidelines">
              <AccordionTriggerGuidelines>
                {locales[lang]['SYMPLA_GUIDELINES']}
              </AccordionTriggerGuidelines>
              <AccordionContent>
                <ul
                  className={classNames(
                    desktopStyles.AccordionContentUl,
                    styles.AccordionContentUlMobile
                  )}
                >
                  {getBottomInfo(lang).map((info) => (
                    <li
                      key={info.key}
                      className={classNames(
                        styles.GuideLinesLi,
                        desktopStyles.AccordionContentLi
                      )}
                    >
                      <h4 className={styles.SymplaInfoBoxTitle}>
                        <a
                          target="_blank"
                          href={info.link}
                          rel="noopener noreferrer"
                          className={styles.SymplaInfoBoxLink}
                        >
                          {info.title}
                        </a>
                      </h4>
                    </li>
                  ))}
                </ul>
              </AccordionContent>
            </Accordion.Item>
          </Accordion.Root>
        </div>
        <div className={styles.BottomLinkContent}>
          <div className={styles.SymplaInfoBox}>
            <div className={styles.SymplaInfoBoxContainer.Desktop}>
              {getBottomInfo(lang).map((info, idx) => (
                <h4
                  className={styles.SymplaInfoBoxTitle}
                  key={`bottom-info-${idx}`}
                >
                  <a
                    target="_blank"
                    href={info.link}
                    rel="noopener noreferrer"
                    className={styles.SymplaInfoBoxLink}
                  >
                    {info.title}
                  </a>
                </h4>
              ))}
            </div>
          </div>
          <div className={styles.CopyRight}>
            <p>
              <b>
                {varReplace(
                  locales[lang]['COPYRIGHT'],
                  new Date().getFullYear()
                )}
              </b>
            </p>
            <p className={styles.CopyRightDesktop}>&nbsp;·&nbsp;</p>
            <p>CNPJ: 14.512.528/0001-54</p>
          </div>
          <p className={styles.CopyRight}>
            Avenida Nossa Senhora do Carmo, 931, 6º andar - Sion, Belo
            Horizonte/MG - 30.320-000
          </p>
          <p className={styles.CopyRight}>
            Precisa de ajuda?
            <a
              target="_blank"
              href="https://ajuda.sympla.com.br/hc/pt-br/requests/new"
              rel="noopener noreferrer"
              aria-label="Entre em contato"
            >
              {locales[lang]['CONTACT_US']}
            </a>
          </p>
        </div>
        <ul className={styles.SymplaInfoBoxIconUl}>
          {getSocials().map((social) => (
            <li className={styles.SymplaInfoBoxIconLi} key={social.key}>
              <a
                target="_blank"
                href={social.link}
                rel="noopener noreferrer"
                className={styles.SymplaInfoBoxIconLink}
                aria-label={social.ariaLabel}
              >
                {social.icon}
              </a>
            </li>
          ))}
        </ul>
      </section>
    </div>
  </footer>
)

export default Footer
